/**
 * Каркас публичной части и ЛК — ТОЧНАЯ КОПИЯ legacy htdocs/core/templates/main.tpl.
 * Классы и структура DOM повторены 1:1 (Bootstrap 3 + assets/css/main.css),
 * чтобы дизайн не отличался от старого сайта.
 *
 * Соответствие legacy:
 *   .masthead        — шапка с названием СНТ
 *   .menu_line       — горизонтальное меню (desktop, hidden-xs)
 *   .navbar          — бургер-меню (mobile)
 *   .fioblock        — ФИО владельца справа в меню, если залогинен
 *   nav-pills        — меню ЛК под шапкой
 *   .pfooter/.footer — подвал со ссылкой на VK
 */

import type { MouseEvent } from 'react'
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'

import { useSession, type MenuItem } from '@/session/SessionProvider'

/** legacy-ссылка выхода из ЛК (views/main.php: 'lk?exit'). */
const EXIT_LINK = 'lk?exit'

export function Layout() {
  // Стили публичной части (main.css, PT Sans Narrow) подключены в index.html —
  // как в legacy main.tpl. Админка гасит их у себя (useDisablePublicCss).
  const { user, owner, menu, lk_menu, site, logout } = useSession()
  const location = useLocation()
  const navigate = useNavigate()

  /** В SPA не переходим по /lk?exit, а гасим сессию и уходим на страницу входа. */
  async function onExit(event: MouseEvent<HTMLAnchorElement>): Promise<void> {
    event.preventDefault()
    await logout()
    navigate('/login')
  }

  // legacy: $cur_link = первый сегмент URL
  const currentLink = location.pathname.split('/')[1] ?? ''

  /**
   * legacy views/main.php:23 — залогиненному пользователю в КОНЕЦ главного меню
   * (после «Личного кабинета») дописывается пункт «Выход» со ссылкой lk?exit.
   * Бекенд его не отдаёт: это чисто пункт интерфейса.
   */
  const mainMenu: MenuItem[] =
    user === null ? menu : [...menu, { link: 'lk?exit', name: 'Выход' }]

  /** legacy: пункт «login» подсвечен, когда пользователь в ЛК (/lk). */
  const isActive = (link: string): boolean =>
    link === currentLink || (link === 'login' && currentLink === 'lk')

  return (
    <>
      <div
        style={{
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top',
          height: '100%',
          width: '100%',
          zIndex: -5,
          position: 'fixed',
          left: 0,
          opacity: 0.3,
        }}
      />

      <div className="container">
        <div className="masthead">
          <h2 className="top-h2">{site.site_title}</h2>
          <h3 className="text-muted top-h3">{site.site_subtitle}</h3>
        </div>
      </div>

      <div className="menu_line hidden-xs">
        <div className="container" style={{ position: 'relative' }}>
          {user !== null && owner !== null && (
            <div className="fioblock">
              <i className="far fa-user-circle" /> {owner.familia} {owner.imuy} {owner.otchestvo}
            </div>
          )}
          <nav>
            <ul className="nav nav-justified">
              {mainMenu.map((item, index) => (
                <li key={`${item.link}-${index}`} className={isActive(item.link) ? 'active' : undefined}>
                  {item.link === EXIT_LINK ? (
                    <a href="/login" onClick={(event) => void onExit(event)} style={{ whiteSpace: 'nowrap' }}>
                      {item.name}
                    </a>
                  ) : (
                    <Link to={`/${item.link}`} style={{ whiteSpace: 'nowrap' }}>
                      {item.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      <nav className="navbar navbar-default hidden-sm hidden-md hidden-lg">
        <div className="container-fluid">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
              aria-expanded="false"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
          </div>
          <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
            <ul className="nav navbar-nav">
              {mainMenu.map((item, index) => (
                <li key={`${item.link}-${index}`} className={isActive(item.link) ? 'active' : undefined}>
                  {item.link === EXIT_LINK ? (
                    <a href="/login" onClick={(event) => void onExit(event)} className="padding_nav">
                      {item.name}
                    </a>
                  ) : (
                    <Link to={`/${item.link}`} className="padding_nav">
                      {item.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>

      <div className="container globalcontentcontainer">
        <div className="row">
          <div className="col-xs-12">
            {user !== null && (
              <div className="row" style={{ paddingTop: 10 }}>
                <div className="col-xs-12">
                  <nav>
                    <ul className="nav nav-pills nav-justified">
                      {lk_menu.map((item, index) => (
                        <li
                          key={`${item.link}-${index}`}
                          className={item.link === currentLink ? 'active' : undefined}
                        >
                          <Link
                            to={`/${item.link}`}
                            className={item.link === currentLink ? 'navpilsflat' : undefined}
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            {item.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </nav>
                </div>
              </div>
            )}

            <Outlet />
          </div>
        </div>
      </div>

      <div className="pfooter" />
      <div className="container">
        <div className="footer">
          <div className="row justify-content-xs-center">
            <div className="col-md-3 col-xs-12" />
            <div className="col-md-6 col-xs-12">
              <p>
                © Разработка и поддержка сайта,{' '}
                <a href="http://airnet.ru/" target="_blank" rel="noreferrer">
                  AirNet
                </a>
                <sup style={{ fontSize: '10px' }}>™</sup> {new Date().getFullYear()}
              </p>
            </div>
            <div className="col-md-3 col-xs-12">
              <a href="https://vk.com/club196660855" target="_blank" rel="noreferrer">
                <div className="vkfooter" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
